<template>
    <div class="content-box">
      <div class="content-body">
        <div class="page-title">问题反馈</div>
      <div class="table-div hover-bg" style="font-size: 16px; margin-top:40px">
        <div v-if="this.showList">
        <div class="search-box">
          <el-form
                  ref="searchForm"
                  size="small"
                  :inline="true"
                  :model="search">
            <el-row class="input-box">
              <el-form-item label="问答状态：">
                <el-select v-model="search.status" placeholder="请选择问答状态"  clearable>
                  <el-option label="待回答" value="1"></el-option>
                  <el-option label="已结束" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="提问时间：" class="ml-lg width-auto">
                <el-date-picker
                        v-model="search.time_range"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="ml-lg">
                <el-button style="background-color: #f16622;border-color:#f16622"
                        type="primary"
                        size="small"
                        @click="funSearch">查 询
                </el-button>
                <el-button style="background-color: #f16622;border-color:#f16622"
                        type="primary"
                        size="small"
                        @click="funEdit(0)">我要提问
                </el-button>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
        <el-table v-if="showNothing==1"
                :data="tableDataFormat"
                :show-header="false"
                size="mini"
                  :row-style="{height: '40px'}"
                style="width: 100%;font-size: 14px;color:#212121;padding-top: 30px;"
                class="no-table_row"
        >
          <el-table-column prop="title" label="标题" width="400px">
            <template slot-scope="scope">
              <div @click="openDetail(scope.row)">
              {{scope.row.title}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="350px" align="right">
            <template slot-scope="scope">
              <div @click="openDetail(scope.row)">
                {{scope.row.status}} <span style="padding-left: 10px;">|</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="获取时间">
            <template slot-scope="scope">
            <div @click="openDetail(scope.row)">
              {{scope.row.created_at}} <span>创建</span>
            </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row class="pagination-box" v-if="totalSum > 10">
          <el-pagination
                  class="paging"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10]"
                  :current-page.sync="pageNo"
                  :page-size="pageSize"
                  :total="totalSum"
                  layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </el-row>
            <div v-if="showNothing==0">
                <div style="padding-top: 20%;padding-left: 40%;">您还没有提问过哦</div>
            </div>
      </div>

        <div v-if="this.addFlag">
            <div class="part-title">
                <span class="el-icon-back" style="cursor: pointer;color: #F16222" @click="goMessage">返回</span>
            </div>
          <div class="doc-api-page">
            <div class="api-content-box">
              <div class="select-content">
                <el-form ref="appForm"
                         class="form-content star-float"
                         :model="editInfo"
                         :rules="rules"
                         label-position="left"
                         label-width="90px">

                  <el-form-item  label="工单标签" prop="tag" :rules="rules.tag" >
                    <el-radio-group v-model="editInfo.tag" @change="onChangeLable" fill="#F16622">
                      <el-radio-button label="1">咨询</el-radio-button>
                      <el-radio-button label="2">报障</el-radio-button>
                      <el-radio-button label="3">需求</el-radio-button>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item  label="业务类型" prop="type" :rules="rules.type">
                    <el-radio-group v-model="editInfo.type">
                      <p>
                        <el-radio label="1">授权</el-radio>
                        <el-radio label="2">消息推送</el-radio>
                        <el-radio label="3">API权限</el-radio>
                        <el-radio label="4">城市车型</el-radio>
                        <el-radio :label="6">计价</el-radio>
                      </p>
                      <p style="padding-top: 10px">
                        <el-radio :label="7">下单</el-radio>
                        <el-radio :label="8">支付</el-radio>
                        <el-radio :label="9">账单</el-radio>
                        <el-radio :label="10">优惠券</el-radio>
                        <el-radio label="5">其他</el-radio>
                      </p>
                    </el-radio-group>
                  </el-form-item>



                  <el-form-item   label="标题" prop="title" :rules="rules.title">
                    <el-input type="text" style="width: 457px;"  show-word-limit v-model="editInfo.title" maxlength="50" clearable placeholder="请输入标题"></el-input>
                  </el-form-item>
                  <div v-show="showLableTwo">
                  <el-form-item   label="app_key" prop="app_key">
                    <el-input v-model="editInfo.app_key" style="width: 457px;" maxlength="50" clearable placeholder="请输入app_key"></el-input>
                  </el-form-item>

                  <el-form-item   label="signature" prop="signature">
                    <el-input :class="[this.tagFlag === 1 ? 'is-required' : '']" v-model="editInfo.signature" style="width: 457px;"  maxlenght="100" clearable placeholder="请输入signature"></el-input>
                  </el-form-item>
                  <el-form-item   label="环境" prop="env">
                    <el-radio v-model="editInfo.env" label="1">测试环境</el-radio>
                    <el-radio v-model="editInfo.env" label="2">正式环境</el-radio>
                  </el-form-item>
                  </div>

                  <el-form-item   label="描述" prop="description" :rules="rules.content">
                    <el-input type="textarea" :rows="6" maxlength="500" style="width: 457px;" show-word-limit v-model.trim="editInfo.description" clearable placeholder="请描述详细问题包括：场景,现象等"></el-input>
                  </el-form-item>


                  <div style="padding-left:90px;position: relative;top: -23px;">
                  <el-upload
                          style="width: 43%"
                          action="/ajax/common/interface/image/upload"
                          :on-preview="handlePreview"
                          :headers="headerData"
                          accept="image/png, image/jpeg, image/jpg"
                          name="image"
                          :on-remove="handleRemove"
                          :before-upload="beforeFileUpload"
                          :before-remove="beforeRemove"
                          :on-success="uploadSuccess"
                          :limit="5"
                          :on-exceed="handleExceed"
                          :file-list="fileList">
                    <el-button style="width: 457px;">
                      <i class="el-icon-plus"></i>
                      添加附件</el-button>
                  </el-upload>
                 </div>

                  <el-button class="edit-submit-btn mt-sm" @click="appSubmit">提交</el-button>
                </el-form>
              </div>
            </div>
          </div>
        </div>

        <div v-if="this.detailFlag">
          <div class="part-title">
            <span class="el-icon-back" style="cursor: pointer;color: #F16222" @click="goMessage">返回</span>
          </div>
          <div class="api-content-box">
            <div class="part-content">
              <div class="info-row">
                <div class="info-value" style="">
                  <span style="font-size: 24px;font-weight: 900;color: #424456;">{{this.ticketDetail.title}}</span>
                </div>
              </div>
              <div class="info-row mt-sm" style="padding-bottom: 16px;font-size: 14px">
                <div class="info-value">

                  <div style="color: gray">
                    <span>{{this.ticketDetail.dev_account}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{this.ticketDetail.created_at}} 创建</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{this.ticketDetail.tag}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{this.ticketDetail.type}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>ID:{{this.ticketDetail.id}}</span>
                  </div>

<!--                  <span style="padding-right: 10px">{{this.ticketDetail.account}}</span>|-->
<!--                  <span style="padding-right: 10px">{{this.ticketDetail.createdAt}}创建</span>|-->
<!--                  <span style="padding-right: 10px">{{this.ticketDetail.label}}</span>|-->
<!--                  <span style="padding-right: 10px">{{this.ticketDetail.type}}</span>|-->
<!--                  <span style="padding-right: 10px">ID:{{this.ticketDetail.id}}</span>-->
                </div>
              </div>

              <div v-if="this.ticketDetail.app_key" style="padding-top: 3px;padding-bottom: 3px;background-color: #8080801c;line-height:30px">
                <div class="info-value">
                  app_key:<span>{{this.ticketDetail.app_key}}</span>
                </div>
                <div class="info-value">
                  signature:<span>{{this.ticketDetail.signature}}</span>
                </div>
                <div class="info-value">
                  环境:<span>{{this.ticketDetail.env==1?'测试环境':'线上环境'}}</span>
                </div>
              </div>

              <div v-if="true">
              <el-form ref="appForm"
                       class="form-content star-float"
                       :model="ticketDetail"
                       label-position="left"
                       label-width="90px">
                <div class="info-row">
                  <div class="info-value" style="padding-top: 20px;">
                    <span style="word-wrap: break-word;">{{this.ticketDetail.description}}</span>
                  </div>
                </div>

                <div style="padding-top: 30px">
                  <div class="app-item" v-for="app in QuestionfileList" :key="app.name">
                    <el-image class="pointer" @click="funPreImg(app)" slot="reference" :src="app.url" alt="app.name" style="max-height: 400px;max-width: 400px">
                    </el-image>
                  </div>
                  <img-preview v-model="imgPreviewShow" :data="imgUrl"></img-preview>

                </div>
              </el-form>
              </div>
              <div v-if="this.edit===1" style="padding-top: 30px;left: -91px;position: relative;">
                <el-form ref="appForm"
                         class="form-content star-float"
                         :model="ticketDetail"
                         label-position="left"
                         label-width="90px">
                  <div>
                  <el-form-item   label="" prop="description" :rules="rules.description">
                    <el-input type="textarea" :rows="6" maxlength="500" style="width: 457px;" show-word-limit v-model.trim="ticketDetail.description" clearable placeholder=""></el-input>
                  </el-form-item>
                  <div style="padding-left:90px;position: relative;top: -23px;">
                    <el-upload
                            style="width: 51%"
                            action="/ajax/common/interface/image/upload"
                            :on-preview="handlePreview"
                            :headers="headerData"
                            accept="image/png, image/jpeg, image/jpg"
                            name="image"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :before-upload="beforeFileUpload"
                            :on-success="uploadSuccess"
                            :on-exceed="handleExceed"
                            :limit="5"
                            :file-list="fileList">
                      <el-button style="width: 457px;">
                        <i class="el-icon-plus"></i>
                        添加附件</el-button>
                    </el-upload>
                  </div>
                  </div>
                  <div class="info-value" v-if="this.edit===1">
                      <el-button class="edit-submit-btn mt-sm" @click="appEditSubmit">提交修改</el-button>
                    <el-button class="edit-submit-btn mt-sm" @click="appCancelSubmit" style="margin-left: 11px;">取消修改</el-button>
                  </div>
                </el-form>
              </div>
              <div v-if="this.ticketDetail.status===1">
              <div v-if="this.edit==0" style="left: -91px; position: relative;padding-bottom: 20px">
                <div v-if="!this.ticketDetail.question_answer_list">
                <el-button class="edit-submit-btn mt-sm" @click="appEditTicket">修改问题</el-button>
              <el-button class="edit-submit-btn mt-sm" @click="appCloseSubmit" style="margin-left: 11px;">关闭问题</el-button>
              <el-button  v-if="this.delay>1" class="edit-submit-btn mt-sm" style="margin-left: 11px;" @click="appUrgentSubmit">催促回复</el-button>
              </div>
              </div>
              </div>



<!--                <div v-if="this.ticketDetail.status===2" style="padding-top: 30px">-->


<!--                  </div>-->
              <div class="info-value" v-if="this.ticketDetail.status===2">
                <el-divider></el-divider>
                <span style="font-size: 20px;font-weight: 900;color: #424456;">回答</span>
                <p style="padding-top: 20px">{{this.ticketDetail.answer}}</p>
                <div style="padding-top: 30px">
                  <div class="app-item" v-for="app in fileAnswerList" :key="app.name">
                    <el-image class="pointer" @click="funPreImg(app)" slot="reference" :src="app.url" alt="app.name" style="max-height: 400px;max-width: 400px">
                    </el-image>
                  </div>
                  <img-preview v-model="imgPreviewShow" :data="imgUrl"></img-preview>

                </div>
              </div>
              <div class="info-value" v-if="this.ticketDetail.status===1">
                <div class="info-value" v-if="this.edit===0">
                  <div v-if="this.ticketDetail.question_answer_list==''">

                  <el-divider></el-divider>
                  <p style="padding-top: 47px;padding-left: 310px;padding-bottom: 46px;background-color: #8080801c;">您的问题已收到，请耐心等待解答...</p>
                <div class="qa-waiting-icon"></div>
                </div></div>
              </div>

              <div v-if="this.editAq" style="padding-top: 30px;left: -91px;position: relative;">
                <el-form ref="appForm"
                         class="form-content star-float"
                         :model="ticketAQDetail"
                         label-position="left"
                         label-width="90px">
                  <div>
                    <el-form-item   label="" prop="description" :rules="rules.description">
                      <el-input type="textarea" :rows="6" maxlength="500" style="width: 457px;" show-word-limit v-model.trim="ticketAQDetail.description" clearable placeholder=""></el-input>
                    </el-form-item>
                    <div style="padding-left:90px;position: relative;top: -23px;">
                      <el-upload
                              style="width: 51%"
                              action="/ajax/common/interface/image/upload"
                              :on-preview="handlePreview"
                              :headers="headerData"
                              accept="image/png, image/jpeg, image/jpg"
                              name="image"
                              :on-remove="handleRemove"
                              :before-remove="beforeRemove"
                              :before-upload="beforeFileUpload"
                              :on-success="uploadSuccess"
                              :on-exceed="handleExceed"
                              :limit="5"
                              :file-list="fileList">
                        <el-button style="width: 457px;">
                          <i class="el-icon-plus"></i>
                          添加附件</el-button>
                      </el-upload>
                    </div>
                  </div>
                  <div class="info-value" v-if="this.editAq">
                    <el-button class="edit-submit-btn mt-sm" style="margin-bottom: 20px;" @click="appEditAqSubmit">提交追问</el-button>
                  </div>
                </el-form>
              </div>


              <div class="info-value" v-if="this.allowQa">
              <el-button class="edit-submit-btn mt-sm" style="margin-bottom: 20px;margin-left: 0px;" @click="appEditAQTicket">追问</el-button>
              </div>

              <div class="info-value" v-if="this.ticketDetail.question_answer_list">
                <el-divider></el-divider>
                <span style="font-size: 20px;font-weight: 900;color: #424456;">回答</span>
                <p style="padding-top: 20px">{{this.ticketDetail.answer}}</p>
                <div style="padding-top: 30px">
                  <div class="app-item" v-for="app in fileAnswerList" :key="app.name">
                    <el-image class="pointer" @click="funPreImg(app)" slot="reference" :src="app.url" alt="app.name" style="max-height: 400px;max-width: 400px">
                    </el-image>
                  </div>
                  <img-preview v-model="imgPreviewShow" :data="imgUrl"></img-preview>

                </div>
              </div>

              <div class="block" v-if="this.ticketDetail.question_answer_list">
                <el-timeline>
                  <el-timeline-item placement="top"
                                    v-for="(activity, index) in questionAnswerList"
                                    :key="index"
                                    :timestamp="activity.title">
                    <el-card>
                      <h4> {{activity.content}}</h4>
                      <div style="padding-top: 30px">
                        <div class="app-item" v-for="app in activity.image_url" :key="app.name">
                          <el-image class="pointer" @click="funPreImg(app)" slot="reference" :src="app.url"
                                    alt="app.name" style="max-height: 400px;max-width: 400px">
                          </el-image>
                        </div>
                        <img-preview v-model="imgPreviewShow" :data="imgUrl"></img-preview>

                      </div>
                    </el-card>

                  </el-timeline-item>
                </el-timeline>
                <div v-if="this.ticketDetail.status===1">
                  <el-button class="edit-submit-btn mt-sm" @click="appCloseSubmit"
                             style="margin-left: 11px;margin-bottom: 40px">关闭问题
                  </el-button>
                </div>
              </div>


            </div>
          </div>
        </div>

  </div>
      </div>
    </div>
</template>

<script>
import Vue from "vue";
import ImgPreview from '../common/hll-img-preview';
import {formatDate, loginPath} from "../../assets/js/common";
import HllSteps from "../common/hll-steps";
import {sandboxRequest} from "../../axios/sandboxRequest";

export default {
    name: 'ticketPage',
    data() {
      return {
        imgUrl:'',
        sleepFlag:false,
        imgPreviewShow: false,
        fileList:[],
        QuestionfileList:[],
        fileAnswerList:[],
        fileQaList:[],
        fileListTemp:[],
        showLableTwo:false,
        headerData: {
          Authorization: localStorage.getItem('token')
        },
        fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
        lablePosition:'right',
        messageId: '',
        showNothing:1,
        uploadLoading1: false,
        uploadLoading2: false,
        pageSize: 10,
        pageNo: 1,
        totalSum: 0,
        showList: true,
        addFlag: false,
        detailFlag:false,
        allowQa:false,
        ticketList: [], // 授权的api列表,
        questionAnswerList:[],
        search: {
          status: null,
          time_range: null,
        },
        editInfo: {
          tag: '', // 标签
          title: '', // 主题
          type: '', // 类型
          app_key: '', // appkey
          signature: '', // signature
          env: '', // 环境
          description:'',
          images:'',
          id:""
        },
        detailItem:{
          label:'',
          value:'',
        },
        detailTypeItem:{
          label:'',
          value:'',
        },
          delay:0,
         edit:0,
        tagFlag:0,
        editAq:false,
        cancelQuestion:'',
        cancelQuestionImg:'',
        ticketAQDetail:{
          description:"",
          image_url:""
        },
        ticketDetail:{
            status:1,
            tag:1,
            type:1,
            app_key:'',
            signature:'',
            env:1,
            title:"",
            description:"",
            images:"[\n" +
                    "    {\n" +
                    "        \"name\":\"tt\",\n" +
                    "        \"url\":\"https://3124.png\"\n" +
                    "    }\n" +
                    "]",
            answer:"",
            answer_image_url:"",
            answer_at:"",
            is_urgent:'',
            dev_account:"",
            id:1,
            created_at:"",
            bigFlag:false,
            allow_qa:false,
          question_answer_list:""
        },
        rules: {
          description: [
            {required: true, message: '请输入描述', trigger: 'blur'}
          ],
          tag: [
            {required: true, message: '请选择标签', trigger: 'blur'}
          ],
          title: [
            {required: true, message: '请输入主题', trigger: 'blur'}
          ],
          type: [
            {required: true, message: '请选择业务类型', trigger: 'blur'}
          ],
          app_key:[],
          signature:[],
          env:[]
        }

      }
    },
    computed: {
      tableDataFormat() {
        return this.ticketList.map(item => {
          item.status = item.status===1?"待回答":"已结束";
          if (item.title.length > 20) {
            item.title= item.title.slice(0,20) + '...'
          }
          return item;
        })
      },
      // 格式化申请开始时间
      created_s() {
        try {
          return formatDate(this.date[0].getTime(), 'yyyy-MM-dd hh:mm:ss');
        } catch (e) {
          return null;
        }
      },
      // 格式化申请开始时间
      created_e() {
        try {
          return formatDate(this.date[1].getTime(), 'yyyy-MM-dd hh:mm:ss');
        } catch (e) {
          return null;
        }
      },
    },
  components: {
    HllSteps,
    ImgPreview
  },
    mounted() {
      this.handleCurrentChange(1);
      this.envIsOpen();
    },
    methods: {
      envIsOpen() { // 沙箱环境是否开启
        sandboxRequest.showSandboxEnv().then(res => {
          this.showSandboxSwitch = res.ret === 0 && res.data;
        })
      },
        // 打开详情
        openDetail(item) {
            this.showList=false;
            this.addFlag=false;
            this.detailFlag=true;
            this.$axios.post("/ajax/ticket/info", {
                id: item.id
            }).then(res => {
              
                this.ticketDetail=res.data.data;
               this.handleFileInfo();
                this.handleQAInfo()
               // this.detailItem=this.$config.ticketLabelMap[this.ticketDetail.tag];
                this.ticketDetail.tag = this.detailItem.label
                this.detailTypeItem=this.$config.ticketTypeMap[this.ticketDetail.type];
                this.ticketDetail.type = this.detailTypeItem.label
                this.ticketDetail.status=item.status==='已结束'?2:1
                this.allowQa = this.ticketDetail.allow_qa
              this.dateTimeStamp = new Date(this.ticketDetail.created_at).getTime()
              let now = new Date().getTime();
              let diffValue = now - this.dateTimeStamp;
              let minute = 1000 * 60;
              let hour = minute * 60;
              this.delay =diffValue/hour;
              this.ticketDetail.created_at=formatDate(this.ticketDetail.created_at,"yyyy-MM-dd");
             ;
            });
        },

      // 处理资料信息展示结构
      handleFileInfo: function () {
        let tempStr = this.ticketDetail.contents.filter(item=>item.contentType==0)[0]
        // if (null != tempStr&&tempStr!='') {
        //   let list=JSON.parse(tempStr);
          this.QuestionfileList = (tempStr.images || []).map((item, index) => {
            return typeof item === "object" ? {
              name: item.name,
              url: item.url
            } : {
              name: '图片' + (index + 1),
              url: item
            };
          })
          this.re
        // }
        // let tempAnswerStr = this.ticketDetail.answer_image_url;
        // if (null != tempAnswerStr&&tempAnswerStr!='') {
        //   let list=JSON.parse(tempAnswerStr);
        let aws = this.ticketDetail.contents.filter(item=>item.contentType==2)[0]
        //  const athis.question_answer_list = aws.content
          this.fileAnswerList = (aws.images || []).map((item, index) => {
            return typeof item === "object" ? {
              name: item.name,
              url: item.url
            } : {
              name: '图片' + (index + 1),
              url: item
            };
          })
        // }

      },

      // 处理资料信息展示结构
      handleQAInfo: function () {
        let tempStr = this.ticketDetail.contents;
        console.log(tempStr)
        // if (null != tempStr&&tempStr!='') {
          // let list=JSON.parse(tempStr);
          this.questionAnswerList = (tempStr || []).map((item, index) => {
            item.type=item.contentType===1?"追问":"追答" ;

            // let tempQaImgUrl = item.image_url;
            // if (null != tempQaImgUrl&&tempQaImgUrl!='') {
            //   let list=JSON.parse(tempQaImgUrl);
            //   this.fileQaList = (list || []).map((item, index) => {
            //     return typeof item === "object" ? {
            //       name: item.name,
            //       url: item.url
            //     } : {
            //       name: '图片' + (index + 1),
            //       url: item
            //     };
            //   })
            // }

            return typeof item === "object" ? {
              title: item.type+" "+item.updated_at,
              content: item.content,
              image_url:item.images
            } : {
              name: '图片' + (index + 1),
              url: item
            };
          });

          if(this.questionAnswerList.length>0){
            this.ticketDetail.question_answer_list = JSON.stringify(this.questionAnswerList)
          }


        // }





      },
      onChangeLable(e){
        if(e==="1"){
           this.showLableTwo=false;
          this.rules.app_key=[{}];
          this.rules.signature=[{}];
          this.rules.env=[{}];
          this.editInfo.app_key='';
          this.editInfo.signature='';
          this.editInfo.env='';
          this.tagFlag=0;
        }
        if(e==="2"){
          this.showLableTwo=true;
          this.rules.app_key=[{required: true, message: 'app_key必填', trigger: 'blur'}];
          this.rules.signature=[{required: true, message: 'signature必填', trigger: 'blur'}];
          this.rules.env=[{required: true, message: 'env必填', trigger: 'blur'}];
          this.tagFlag=1;
        }
        if(e==="3"){
          this.tagFlag=0;
          this.showLableTwo=false;
          this.rules.app_key=[{}];
          this.rules.signature=[{}];
          this.rules.env=[{}];
          this.editInfo.app_key='';
          this.editInfo.signature='';
          this.editInfo.env='';
        }
      },
      handleRemove(file, fileList) {
          this.fileList=[]
          this.fileList=fileList;
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
          if(this.bigFlag){
            return this.$confirm(`确定移除 ${ file.name }？`).then(()=>{
              this.bigFlag=true;
            }).catch(() => {
              this.bigFlag=true;
            });
          }else {
            return this.$confirm(`确定移除 ${ file.name }？`).then(()=>{
            });
          }

      },

      funSearch() {
        this.$refs['searchForm'].validate((valid) => {
          if (valid) {
            this.handleCurrentChange(1);
          }
        })
      },

      // 新增工单
      funEdit(action, item) {
        let token = localStorage.getItem('token')
        if(!token){
          this.goLogin()
          return;
        }
        this.showList=false;
        this.addFlag=true;
      },
      goLogin() {
        this.$router.push({path: loginPath()})
      },

      handleSizeChange(size) {
        this.pageNo = 1;
        this.pageSize = size;
        this.getTicketListData();
      },
      handleCurrentChange(index) {
        this.pageNo = index;
        this.getTicketListData();
      },
      // 获取数据列表
      getTicketListData() {
        this.fileList=[];
        let created_s = null;
        let created_e = null;
        if(this.search.time_range && this.search.time_range.length) {
          created_s = formatDate(this.search.time_range[0], 'yyyy-MM-dd') + ' 00:00:00';
          created_e = formatDate(this.search.time_range[1], 'yyyy-MM-dd') + ' 23:59:59';
        }
        this.$axios.post("/ajax/ticket/search", {
          ...this.search,
          created_s: created_s,
          created_e: created_e,
          page_size: this.pageSize,
          page_no: this.pageNo
        }).then(res => {
            if(res.data.data.list.length===0){
              if(this.search.time_range===null&&this.search.status===null){
                this.showNothing=0;
              }else {
                this.showNothing=1;
              }
            }else {
              this.showNothing=1;
            }
          this.ticketList=[];
          this.ticketList = res.data.data.list || [];
          this.totalSum = parseInt(res.data.data.total);
          this.ticketList.map(item => {
            item.created_at=formatDate(item.created_at,'yyyy-MM-dd')
            return item;
          })

          // this.ticketList=[];
          // this.ticketList.push({
          //   title:"你好吗",
          //   id:3333,
          //   status:1,
          //   createdAt:'2021-08-08',
          //   account:'行者孙',
          //   type:1,
          //   tag:1,
          //   content:"开放平台如何接入"
          //
          // });
          // this.ticketList.push({
          //   title:"你好吗",
          //   id:33334,
          //   status:2,
          //   account:'tommy',
          //   createdAt:'2021-08-09',
          //   type:1,
          //   tag:2,
          //   content:"开放平台如何接入"
          // });
          // this.ticketList.push({
          //   title:"你eeeeeeeeeeeeeeeeeeeeeeee好吗",
          //   status:2,
          //   id:45,
          //   createdAt:'2021-08-09',
          //   account:'8987977',
          //   type:1,
          //   tag:3,
          //   content:"开放平台如何接入"
          // });
          // this.totalSum = 2;
        }).catch(e => {
          this.showNothing=0;
        });
      },
      // 图片预览
      funPreImg(img) {
          this.imgPreviewShow = true;
          this.imgUrl=img.url;
      },
      beforeFileUpload(file) {
        let isValid = true;
        let strArr = file.name.split('.');
        let type = strArr[strArr.length - 1].toLowerCase();
        if (file.size / 1024 / 1024 > 2) {
          isValid = false;
          this.bigFlag=true;
          this.$message.error('图片不能大于2M');
        }
        if(['jpeg', 'jpg', 'png'].indexOf(type) === -1) {
          isValid = false;
          this.$message.error('图片格式仅支持 JPEG、JPG、PNG');
        }
        isValid && (this.uploadLoading1 = true);
        return isValid;
      },
      uploadSuccess(res, file,fileList) {
        if (res.ret === 0) {
          if(file.name.length > 20){
            file.name= file.name.slice(0,30) + '...'
          }
          this.fileList=[];
          this.fileList=fileList;
        }
      },
      uploadError(res, file) {
        this.uploadLoading1 = false;
        this.$message.error('上传图片失败');
      },
      appSubmit() {
        if(this.isLoading) {
          return ;
        }
        this.fileListTemp=[];
        this.fileList.forEach(item =>{
          if(item.url!==undefined){
            // this.fileListTemp.push(item.url);
            this.fileListTemp.push({
              "name":item.name,
              "url":item.url
            });
          }else {
            // this.fileListTemp.push(item.response.data);
            this.fileListTemp.push({
              "name":item.name,
              "url":item.response.data
            });
          }
        });
        if(this.editInfo.description===""){
          this.$message.error('请输入描述');
        }
        this.$refs.appForm.validate(valid => {
          if (valid) {
              let url = '/ajax/ticket/add';
            this.showCommonLoading();
            this.$axios.post(url, {...this.editInfo,
              images:this.fileListTemp
            }).then(res => {
              this.reset();
              this.showList=true;
              this.addFlag=false;
              this.detailFlag=false;
              this.fileList=[];
              this.$message.success('反馈成功');
              this.hideCommonLoading();
              this.edit=0;
              this.sleep(700);
            }).catch(e => {
              this.hideCommonLoading();
            });
          }
        })
      },
      reset(){
        this.editInfo.tag='';
        this.editInfo.title='';
        this.editInfo.type='';
        this.editInfo.app_key='';
        this.editInfo.env='';
        this.editInfo.description='';
        this.editInfo.images='';
        this.editInfo.id='';
        this.editInfo.signature='';
        this.fileList=[];
        this.onChangeLable("1")

      },
      appEditTicket(){
        this.edit=1;
        this.cancelQuestion=this.ticketDetail.description;
        this.cancelQuestionImg=this.ticketDetail.images;
        let tempStr = this.ticketDetail.images;
        if (null != tempStr&&tempStr!='') {
          let list=JSON.parse(tempStr);
          this.fileList = (list || []).map((item, index) => {
            return typeof item === "object" ? {
              name: item.name,
              url: item.url
            } : {
              name: '图片' + (index + 1),
              url: item
            };
          })
        }
      },
      appEditAQTicket(){
        this.editAq=true;
        this.allowQa=false;
      },
      appCancelSubmit(){
        this.edit=0;
        this.ticketDetail.description=this.cancelQuestion;
        this.ticketDetail.images= this.cancelQuestionImg;
        let tempStr = this.ticketDetail.images;
        if (null != tempStr&&tempStr!='') {
          let list=JSON.parse(tempStr);
          this.fileList = (list || []).map((item, index) => {
            return typeof item === "object" ? {
              name: item.name,
              url: item.url
            } : {
              name: '图片' + (index + 1),
              url: item
            };
          })
        }
      },
      appEditSubmit() {
        if(this.isLoading) {
          return ;
        }
        if(this.ticketDetail.description===''){
          this.$message.error('问题描述必填！');
        }
        this.fileListTemp=[];
        this.fileList.forEach(item =>{
          if(item.url!==undefined){
            // this.fileListTemp.push(item.url);
            this.fileListTemp.push({
              "name":item.name,
              "url":item.url
            });
          }else {
            // this.fileListTemp.push(item.response.data);
            this.fileListTemp.push({
              "name":item.name,
              "url":item.response.data
            });
          }
        });

        this.$confirm('确认修改问题?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$refs.appForm.validate(valid => {
            if (valid) {
              let url = '/ajax/ticket/update';
              this.showCommonLoading();
              this.$axios.post(url, {
                id:this.ticketDetail.id,
                images:this.fileListTemp,
                description:this.ticketDetail.description
              }).then(res => {
                this.hideCommonLoading()
                this.showList=true;
                this.addFlag=false;
                this.detailFlag=false;
                this.fileList=[];
                this.fileListTemp=[];
                this.edit=0;
                this.$message.success('修改成功');
                this.sleep(700);
              }).catch(e => {
                this.hideCommonLoading();
              });
            }
          })
        }).catch(() => {});


      },
      appEditAqSubmit() {
          debugger
        if(this.isLoading) {
          return ;
        }
        if(this.ticketAQDetail.description===''){
          this.$message.error('问题描述必填！');
          return;
        }
        this.fileListTemp=[];
        this.fileList.forEach(item =>{
          if(item.url!==undefined){
            // this.fileListTemp.push(item.url);
            this.fileListTemp.push({
              "name":item.name,
              "url":item.url
            });
          }else {
            // this.fileListTemp.push(item.response.data);
            this.fileListTemp.push({
              "name":item.name,
              "url":item.response.data
            });
          }
        });

        this.$confirm('确认追问?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$refs.appForm.validate(valid => {
            if (valid) {
              let url = '/ajax/ticket/update/qa';
              this.showCommonLoading();
              this.$axios.post(url, {
                ticket_no:this.ticketDetail.id,
                image_url:JSON.stringify(this.fileListTemp),
                content:this.ticketAQDetail.description,
                type:1
              }).then(res => {
                this.hideCommonLoading()
                this.showList=true;
                this.addFlag=false;
                this.detailFlag=false;
                this.fileList=[];
                this.fileListTemp=[];
                this.edit=0;
                this.editAq=false;
                this.allowQa=false;
                this.$message.success('修改成功');
                this.sleep(700);
              }).catch(e => {
                this.hideCommonLoading();
              });
            }
          })
        }).catch(() => {});


      },

      appCloseSubmit() {

        if(this.isLoading) {
          return ;
        }
        if(this.ticketDetail.status!==1){
          return;
        }

        this.$confirm('确认关闭问题?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$refs.appForm.validate(valid => {
            if (valid) {
              this.$refs.appForm.validate(valid => {
                if (valid) {
                  let url = '/ajax/ticket/close';
                  this.showCommonLoading();
                  this.$axios.post(url, {
                    id:this.ticketDetail.id
                  }).then(res => {
                    this.hideCommonLoading()
                    this.showList=true;
                    this.addFlag=false;
                    this.detailFlag=false;
                    // this.getTicketListData();
                    this.$message.success('关闭成功');
                    this.sleep(700);

                  }).catch(e => {
                    this.hideCommonLoading();
                  });
                }
              })
            }
          })
        }).catch(() => {});


      },

      appCloseAQSubmit() {

        if(this.isLoading) {
          return ;
        }
        if(this.ticketDetail.status!==1){
          return;
        }

        this.$confirm('确认关闭问题?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$refs.appForm.validate(valid => {
            if (valid) {
              this.$refs.appForm.validate(valid => {
                if (valid) {
                  let url = '/ajax/ticket/close/aq';
                  this.showCommonLoading();
                  this.$axios.post(url, {
                    id:this.ticketDetail.id
                  }).then(res => {
                    this.hideCommonLoading()
                    this.showList=true;
                    this.addFlag=false;
                    this.detailFlag=false;
                    // this.getTicketListData();
                    this.$message.success('关闭成功');
                    this.sleep(700);

                  }).catch(e => {
                    this.hideCommonLoading();
                  });
                }
              })
            }
          })
        }).catch(() => {});


      },

      sleep(n) {
        let start = new Date().getTime();
        while (true) {
          if (new Date().getTime() - start > n) {
            this.getTicketListData();
            break;
          }
        }
      },

      appUrgentSubmit() {
        if(this.isLoading) {
          return ;
        }
        if(this.ticketDetail.is_urgent===1){
          this.$message.success('催促成功');
          return;
        }
        this.$refs.appForm.validate(valid => {
          if (valid) {
            let url = '/ajax/ticket/urgent';
            this.showCommonLoading();
            this.$axios.post(url, {
              id:this.ticketDetail.id
            }).then(res => {
              this.hideCommonLoading()
              this.showList=true;
              this.addFlag=false;
              this.detailFlag=false;
              this.$message.success('催促成功');
              this.sleep(700);
            }).catch(e => {
              this.hideCommonLoading();
            });
          }
        })
      },


        goMessage(){
            this.handleCurrentChange(1);
            this.fileListTemp=[];
            this.fileList=[];
            this.showList=true;
            this.addFlag=false;
            this.detailFlag=false;
            this.reset();
            this.ticketDetail={}
            this.edit=0;
          this.editAq=false;
          this.allowQa=false;
          this.showLableTwo=false;
          this.rules.app_key=[{}];
          this.rules.signature=[{}];
          this.rules.env=[{}];
        },

    }
  }
</script>



<style lang="scss">
.qa-waiting-icon {
    display: inline-block;
    vertical-align: middle;
    height: 50px;
    width: 50px;
    margin-right: 18px;
    background: url("../../assets/img/index/happy.png");
  left: 246px;
  top: -78px;
  position: relative;
  }

.doc-table-box {
    .el-table--mini,
    .el-table--small,
    .el-table__expand-icon {
      font-size: 13px;
    }
    .el-table__body {
      width: 100%;
    }
    .el-table__placeholder {
      margin-left: 1px;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        top: -14px;
        left: 50%;
        margin-left: -1px;
        width: 0;
        height: 20px;
        border-left: 1px dashed #ccc;
      }
      &+.el-table__placeholder {
        display: none;
      }
    }
    .el-table__expand-icon {
      margin-right: 1px !important;
    }
  }

</style>
<style lang="scss" scoped>

.content-box {
  position: center;
  width: 60%;
  min-width: 1000px;
  margin: 50px auto;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  min-height: 500px;
}
.content-body {
  padding: 0px 40px 0px 40px;
}

.search-box {
  .el-input__inner {
      width: 221px;
      height: 34px;
      line-height: 34px;
    }
  }
.el-input{
  width: 300px;
}
.el-textarea{
  width: 300px;
}

.doc-api-page {
    width: 1170px;
    padding: 0 0 30px;
    margin: 0 auto;
  }
.edit-submit-btn {
  background: #F16622;
  color: #fff;
  margin-left: 92px;
  margin-top: 20px;
  border: none;
}
.part-title {
    width: 100%;
    line-height: 35px;
    color: #424456;
    font-size: 15px;
    padding-bottom: 15px;
    font-weight: bold;
}
.el-upload-list {
  .el-upload-list--text {
    width: 50%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/help/ticket.vue